import { createAction } from "redux-actions";

export default createAction("DISMISS_ALL_MESSAGES");
